import PropTypes from 'prop-types';
import React, { Component } from 'react';

import ProductList from '../../product-list';

export default class Products extends Component {

  /* Lifecycle */

  constructor(props) {
    super(props);

    this.clickProductHandler = this.clickProductHandler.bind(this);
  }

  /* Handlers */

  clickProductHandler(product, category) {
    const { onSelect } = this.props;

    if (onSelect) {
      onSelect(product, category, this);
    }
  }

  /* Render */

  render() {
    const { products, category } = this.props;

    return (
      <ProductList
        category={category}
        products={products}
        onClickProduct={this.clickProductHandler}
      />
    );
  }
}

Products.propTypes = {
  products: PropTypes.array,
  // config: PropTypes.any,
  category: PropTypes.object,
  onSelect: PropTypes.func,
};



// WEBPACK FOOTER //
// ./js/views/systems/detail/design/add-product/products/index.jsx